import React, {useState} from "react";

const PasswordResetModal = ({onClose}) => {
    const [email, setEmail] = useState("");
    const [message, setMessage] = useState("");
    const [loading, setLoading] = useState(false);
    const apiUrl = process.env.REACT_APP_API_BASE_URL;

    const handleRequest = async (e) => {
        e.preventDefault();
        setLoading(true);
        setMessage(""); // Clear any previous message
        try {
            const response = await fetch(`${apiUrl}/auth/password-reset/request`, {
                method: "POST",
                headers: {"Content-Type": "application/json"},
                body: JSON.stringify({email}),
            });
            const data = await response.json();
            if (!response.ok) throw new Error(data.detail || "Failed to send reset email.");
            setMessage("Password reset email sent successfully.");
        } catch (error) {
            setMessage(error.message || "Error sending reset email.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div
            style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                backgroundColor: "rgba(0, 0, 0, 0.5)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 1000,
            }}
        >

                     <div className="wrap-login100">
                        <h4></h4>
                         <form className="login100-form validate-form" onSubmit={handleRequest}>
                            <span className="login100-form-title p-b-26">
						Request Password Reset
					</span>
                             <div className="form-group">
                                 <input
                                     type="email"
                                     className="input100"
                                     placeholder="Enter your email"
                                     value={email}
                                     onChange={(e) => setEmail(e.target.value)}
                                     required
                                 />
                                 <span className="focus-input100" data-placeholder="Email"></span>
                             </div>
                             {message && (
                                 <p style={{color: message.includes("successfully") ? "green" : "red"}}>
                                     {message}
                                 </p>
                             )}
                             <div className="container-login100-form-btn">
                                 <div className="wrap-login100-form-btn">
                                     <div className="login100-form-bgbtn"></div>
                                     <div className="">
                                         <button type="submit" className="login100-form-btn" disabled={loading}>
                                             {loading ? "Sending..." : "Send Reset Email"}
                                         </button>

                                     </div>
                                 </div>
                             </div>
                             <div className="container-login100-form-btn">
                                 <div className="wrap-login100-form-btn">
                                     <div className="login100-form-bgbtn"></div>
                                     <div className="">

                                         <button type="button" className="login100-form-btn" onClick={onClose}>
                                             Close
                                         </button>
                                     </div>
                                 </div>
                             </div>
                         </form>
                     </div>

        </div>

    );
};

export default PasswordResetModal;